import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useFeatureFlag } from '../../utils/featureFlags';
import ProviderInsuranceTable from '../provider-insurance-table/ProviderInsuranceTable';

interface ProviderInsuranceModalProps {
  isOpen: boolean;
  onClose: () => void;
  providerId: string;
  practiceIds: string[];
  providerName?: string;
  onSaved?: () => void; // Callback to refresh data after save
}

const ProviderInsuranceModal: React.FC<
  ProviderInsuranceModalProps
> = ({
  isOpen,
  onClose,
  providerId,
  practiceIds,
  providerName = 'Provider',
  onSaved,
}) => {
  const isProviderInsuranceHotfixEnabled = useFeatureFlag(
    'provider_insurance_hotfix_v1'
  );

  const [refreshKey, setRefreshKey] = useState(0);

  const handleTableRefresh = () => {
    setRefreshKey((prev: number) => prev + 1);
    onSaved?.();
  };

  if (!isProviderInsuranceHotfixEnabled) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent maxW="90vw" maxH="90vh">
        <ModalHeader>
          <Flex direction="column" gap={2}>
            <Text
              fontSize="1.25rem"
              fontWeight="700"
              color="text.secondary"
            >
              Insurance Plans - {providerName}
            </Text>
            <Text
              fontSize="0.875rem"
              color="gray.600"
              fontWeight="400"
            >
              Edit insurance plan status and age ranges for each plan.
              The status dropdown combines both credential status and
              patient acceptance into a single, clear selection. Make
              multiple changes and save them all at once using the
              bulk save feature.
            </Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6} overflowY="auto" maxH="calc(90vh - 200px)">
          <ProviderInsuranceTable
            providerId={providerId}
            practiceIds={practiceIds}
            title=""
            hideProviderColumn={true}
            refreshKey={refreshKey}
            onSaved={handleTableRefresh}
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ProviderInsuranceModal;
